import script from "./InputCheck.vue?vue&type=script&setup=true&lang=js"
export * from "./InputCheck.vue?vue&type=script&setup=true&lang=js"

import "./InputCheck.vue?vue&type=style&index=0&id=87f90ade&lang=css"

const __exports__ = script;

export default __exports__